<sfx-navigation-toolbar layout="column" data-flex="none" (closeEvent)="close()">
    <div navigationToolbarTitle>
        <span translate>Billing</span>
    </div>
    <a navigationToolbarButton icon="sf-icon-list" ref=".overview">
        {{ 'Overview' | translate }}
    </a>
    <a navigationToolbarButton icon="sf-icon-history" ref=".history" *ngIf="Stripe">
        {{ 'History' | translate }}
    </a>
    <a navigationToolbarButton icon="sf-icon-description" ref=".invoice" *ngIf="Stripe">
        {{ 'Invoicing' | translate }}
    </a>
</sfx-navigation-toolbar>

<sfx-content data-layout="column" data-flex="noshrink">
    <sfx-section disableContentPadding data-layout="column" data-flex="noshrink">
        <ui-view class="panel-view" data-layout="column" data-flex="noshrink">

        </ui-view>
    </sfx-section>
</sfx-content>
